//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/**
 * Reduce an array of items to an indexed object in a typesafe way.
 * @param items Array of items to reduce
 * @param map Function that maps the item to a key-value pair for the output object
 */
export function reduceToRecord<T, K extends PropertyKey, V>(
  items: readonly T[],
  map: (item: T) => [K, V],
): Record<K, V> {
  const acc = {} as Record<K, V>;
  items.forEach((item) => {
    const [key, value] = map(item);
    acc[key] = value;
  });
  return acc;
}
